import { IconButton } from "@material-ui/core";
import Tooltip from "@material-ui/core/Tooltip";
import React, { useEffect, useState } from "react";
import { ReactComponent as CloseIcon } from "../../themes/Icons/close_icon.svg";
import {
  CloseModalAppointment,
  ContentDescriptLang,
  ContentFlag,
  ContentModalAppointment,
  ContentTimeAppointment,
  TextModalAppointment,
  ButtonAppointmentCancel,
  ButtonAppointmentConfirm,
  useStyles,
} from "./ModalAppointment.styled";
import PortalModal from "../../Portals";
import moment from "moment";
import Flag from "react-flagkit";
import PropTypes from "prop-types";

const ModalAppointment = ({
  userData,
  confirmAppointment,
  openAppointmentModal,
  setOpenAppointmentModal,
}) => {
  const [language, setLanguage] = useState({});
  const [appointment, setAppointment] = useState({});
  const classes = useStyles({
    language: language,
  });

  let coachStartDate = () => {
    if (openAppointmentModal?.turnsAvailable?.length > 0) {
      return moment.utc(openAppointmentModal?.turnsAvailable[0].start).format();
    }
    return null;
  };

  let coachEndDate = () => {
    if (openAppointmentModal?.turnsAvailable?.length > 0) {
      return moment
        .utc(openAppointmentModal?.turnsAvailable[0].end)
        .format();
    }
    return null;
  };

  useEffect(() => {
    if (language.idLanguage) {
      setAppointment({
        eventName: "Requested counselling",
        eventDescription: "Requested counselling",
        eventType: "PRIVATE",
        eventStatus: "ACTIVE",
        groups: [],
        photoUri: "",
        speakers: [],
        eventUri: "",
        languageId: language.idLanguage,
        cityId: userData?.location?.cityId,
        countryId: userData?.location?.countryId,
        eventCategoryId: 1,
        startDate: coachStartDate(),
        finishDate: coachEndDate(),
        individualGuests: [openAppointmentModal?.userId, userData?.userId],
        participantIsRequired: true,
        participantsLimit: null,
      });
    }
  }, [
    language,
    openAppointmentModal,
    userData?.location?.cityId,
    userData?.location?.countryId,
    userData?.userId,
  ]);

  return (
    <PortalModal>
      <ContentModalAppointment>
        <CloseModalAppointment>
          <span style={{ marginLeft: "0.2em" }}>{"Confirm"}</span>
          <Tooltip title="close">
            <IconButton onClick={() => setOpenAppointmentModal(null)}>
              <CloseIcon />
            </IconButton>
          </Tooltip>
        </CloseModalAppointment>
        <TextModalAppointment>
          <ContentTimeAppointment>
            <p style={{ fontWeight: "600", fontSize: "12px" }}>
              Today{" "}
              {moment(
                openAppointmentModal?.turnsAvailable?.length > 0
                  ? openAppointmentModal?.turnsAvailable[0].start
                  : "",
                "YYYY-MM-DD"
              ).format("YYYY-MM-DD")}
            </p>
            <p style={{ fontWeight: "300", fontSize: "24px" }}>
              {moment(
                openAppointmentModal?.turnsAvailable?.length > 0
                  ? openAppointmentModal?.turnsAvailable[0].start
                  : ""
              ).format("LT")}
            </p>
          </ContentTimeAppointment>
          <p className="text-center" style={{ fontSize: "18px" }}>
            {"Please confirm appointment"}
          </p>
          <ContentDescriptLang>
            Select language:
            {openAppointmentModal?.wellnessCoachesLanguages &&
              openAppointmentModal?.wellnessCoachesLanguages?.length > 0 &&
              openAppointmentModal?.wellnessCoachesLanguages?.map(
                (item, index) => {
                  return (
                    <Tooltip title={item?.idLanguage} key={index}>
                      <ContentFlag className="text-center mt-2 mb-0">
                        <Flag
                          className={classes.languages}
                          role="button"
                          onClick={() => {
                            setLanguage({
                              id: index,
                              active: index === language.id ? true : false,
                              idLanguage: item?.idLanguage,
                            });
                          }}
                          country={`${item?.idLanguage === "en"
                            ? "US"
                            : item?.idLanguage.toUpperCase()
                            }`}
                        />
                      </ContentFlag>
                    </Tooltip>
                  );
                }
              )}
          </ContentDescriptLang>
        </TextModalAppointment>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <ButtonAppointmentConfirm
            onClick={() => confirmAppointment(appointment)}
          >
            Ok
          </ButtonAppointmentConfirm>
          <ButtonAppointmentCancel
            onClick={() => setOpenAppointmentModal(null)}
          >
            Cancel
          </ButtonAppointmentCancel>
        </div>
      </ContentModalAppointment>
    </PortalModal>
  );
};
export default ModalAppointment;

ModalAppointment.propTypes = {
  openAppointmentModal: PropTypes.object,
  setOpenAppointmentModal: PropTypes.func,
  userData: PropTypes.object,
  confirmAppointment: PropTypes.func,
};